module.exports = __webpack_public_path__ + "media/ike.e712c612.wav";